export const UPDATE_MONITORS = 'UPDATE_MONITORS';
export const RESET_MONITORS = 'RESET_MONITORS';
export const UPDATE_TEMPORAL_DATA = 'UPDATE_TEMPORAL_DATA';
export const RESET_TEMPORAL_DATA = 'RESET_TEMPORAL_DATA';
export const ENABLE_LOADING_TEMPORAL = 'ENABLE_LOADING_TEMPORAL';
export const DISABLE_LOADING_TEMPORAL = 'DISABLE_LOADING_TEMPORAL';
export const ENABLE_LOADING_SPATIAL = 'ENABLE_LOADING_SPATIAL';
export const DISABLE_LOADING_SPATIAL = 'DISABLE_LOADING_SPATIAL';
